import { DropzoneRootProps } from 'react-dropzone'
import styled from 'styled-components'
import { SpaceProps, space } from 'styled-system'

import { filterSpaceProps } from '@/helpers/styled-props'

export const StyledDropzone = styled.div.withConfig({
  shouldForwardProp: filterSpaceProps(),
})<DropzoneRootProps & SpaceProps & { $isFocused?: boolean; $failed?: boolean }>`
  height: auto;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: ${({ theme }) => theme.space.S8} ${({ theme }) => theme.space.S16};
  border-radius: 5px;
  border: ${({ theme }) => `dashed 1px ${theme.colors.grey}`};
  transition: border-color 0.2s;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.white};

  &:hover {
    border-color: ${({ theme }) => theme.colors.violet};
  }

  ${({ $isFocused, theme }) => $isFocused && `border-color: ${theme.colors.violet}`}

  ${space}
`

export const StyledInput = styled.input`
  opacity: 0;
  height: 0;
  width: 0;
`
